module.exports = __webpack_public_path__ + "img/logo_oragen.2bac3682.png";